
<template>
    <div>
        <q-card class="text-caption">
            <q-card-section>
                <div>CONTACT INFORMATION</div>
            </q-card-section>
            <q-separator/>
            <q-card-section>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Mobile No 
                    </div>
                    <div class="col-6">
                        : {{StoreStateAOD.ContactInformation.MobileNo}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Email Address
                    </div>
                    <div class="col-6">
                        : {{StoreStateAOD.ContactInformation.EmailAddress}}
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryContactlInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>